import { render } from "./BookingHotelForm.vue?vue&type=template&id=30814f9c&scoped=true"
import script from "./BookingHotelForm.vue?vue&type=script&lang=js"
export * from "./BookingHotelForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-30814f9c"

export default script